import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {AdminControlService} from '../../@shared/services/admin-control.service';
import {CacheService} from '../../@shared/services/cache.service';
import {ImUserService} from '../../@shared/services/im-user.service';

export enum Mode {
    create = 'create',
    update = 'update'
}

@Component({
    selector: 'app-update-user',
    templateUrl: './update-user.component.html',
    styleUrls: ['./update-user.component.scss']
})

export class UpdateUserComponent implements OnInit {

    userForm: FormGroup;
    companyGroupListingForm: FormGroup;
    businessEntityListing: any;
    businessEntityGroupListing: any;
    displayBasic: boolean;
    currentMode: Mode;
    user: any;
    roles: any;
    selectedBusinessEntityName: any;
    togglePassword: boolean;
    businessEntityName: any;
    groupName: any;
    rolesOfSelectedUser: any;
    businessEntityGroupAction: boolean;
    domainGroupAction: boolean;
    domains: any;
    domainGroup: any;
    toggleGroupForm: boolean;
    domainGroupListingForm: FormGroup;
    toggleDisableField: boolean;
    selectedMultipleRoles: any;
    cachedLoggedInUser = this.cacheService.retrieveParsedResponse('loggedInUser');
    loggedInUser: any;
    stdCodes: any;
    optAction = 'in';

    constructor(private adminRoute: AdminControlService, private activatedRoute: ActivatedRoute, private messageService: MessageService,
                private cacheService: CacheService,
                private imUserService: ImUserService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.createUserForm();
        this.getDomainGroupList();

        this.getLoggedInUser(this.cachedLoggedInUser?.userId);
        this.getStdCodes();
        this.getRoles();
        this.getDomains();
        this.getBusinessEntityListing();
        this.getBusinessEntityGroupList();
        this.companyGroupForm();
        this.domainGroupForm();
        this.activatedRoute.queryParams.subscribe((x) => {
            const userId = x?.userId;
            const updatePassword = x.updatePassword;
            if (!userId) {
                this.createUserForm();
                this.togglePassword = false;
                this.currentMode = Mode.create;
                this.toggleDisableField = true;
            } else if (updatePassword && userId) {
                this.togglePassword = true;
                this.getUserByUserID(userId);
                this.currentMode = Mode.update;
                this.toggleDisableField = true;
            } else {
                this.togglePassword = false;
                this.getUserByUserID(userId);
                this.currentMode = Mode.update;
                this.toggleDisableField = false;
            }
        });
    }

    getDomains() {
        this.adminRoute.getDomainVOList()
            .subscribe(
                (res) => {
                    this.domains = res;
                },
                // tslint:disable-next-line:no-shadowed-variable
                error => {
                    this.messageService.add({
                        summary: 'Unable to get Domains !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                }
            );
    }

    getDomainGroupList() {
        this.adminRoute.getDomainGroupList()
            .subscribe((res) => {
                this.domainGroup = res;
                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {
                this.messageService.add({
                    summary: 'Unable to get Domain Group !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    getUserByUserID(userId) {
        this.adminRoute.getUserByUserID(userId)
            .subscribe((res) => {
                this.user = res;
                this.rolesOfSelectedUser = this.user.roles;
                const businessEntityGroupId = this.user?.businessEntityGroupId;
                if (this.user?.businessEntityGroupId) {
                    this.getBusinessGroupByGroupId(businessEntityGroupId);
                }
                if (this.user?.businessEntities) {
                    this.businessEntityName = this.user?.businessEntities[0].entityName;
                    this.userForm.patchValue({
                        entityName: this.businessEntityName,
                    });
                }
                this.createUserForm(this.user);
                if (res?.whatsAppPhoneNumber) {
                    this.optAction = 'out';
                }
                // tslint:disable-next-line:no-shadowed-variable
            }, error => {
                this.messageService.add({
                    summary: 'Unable to Fetch User !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    getRoles() {
        this.adminRoute.getRoles()
            .subscribe((res) => {
                this.roles = res;
            }, error => {
                this.messageService.add({
                    summary: 'Unable to get Roles !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    getBusinessGroupByGroupId(businessEntityGroupId: any) {
        this.adminRoute.getBusinessGroupByGroupId(businessEntityGroupId)
            .subscribe((res) => {
            }, error => {
                this.messageService.add({
                    summary: 'Unable to Fetch Group !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    getBusinessEntityGroupList() {
        this.adminRoute.getBusinessEntityGroupList()
            .subscribe((x) => {
                this.businessEntityGroupListing = x;
            }, (error) => {
                this.messageService.add({
                    summary: 'Unable to Fetch Business Entity Group !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    getBusinessEntityListing() {
        this.adminRoute.getBusinessEntityListing()
            .subscribe((x) => {
                this.businessEntityListing = x;
            }, error => {
                this.messageService.add({
                    summary: 'Unable to Fetch Business Entity !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    submitUserForm() {
        const user = this.userForm.value;
        if (!user?.whatsAppPhoneNumber && user?.whatsAppPhoneStdCode) {
            this.messageService.add({
                summary: 'Mandatory Fields Message',
                severity: 'info',
                detail: 'Please Provide Whatsapp Number or Remove Std Code',
                key: 'success-message',
                sticky: false
            });
            return;
        }

        if (user?.whatsAppPhoneNumber && !user?.whatsAppPhoneStdCode) {
            this.messageService.add({
                summary: 'Mandatory Fields Message',
                severity: 'info',
                detail: 'Please Provide Std Code or Remove WhatsApp Number',
                key: 'success-message',
                sticky: false
            });
            return;
        }

        if (user?.whatsAppPhoneNumber && user?.whatsAppPhoneStdCode) {
            user.whatsAppPhoneNumber = user?.whatsAppPhoneNumber.toString();
        }
        if (this.currentMode === 'update') {
            this.adminRoute.updateUser(user)
                .subscribe((res) => {
                    this.messageService.add({
                        summary: 'User Updated Successfully',
                        severity: 'success',
                        detail: 'User Updated....',
                        key: 'success-message',
                        sticky: false
                    });
                }, error => {
                    this.messageService.add({
                        summary: 'Unable to Update Current User !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                });
        } else if (this.currentMode === 'create') {
            this.adminRoute.createUser(user)
                .subscribe((res) => {
                    console.log(res);
                    this.messageService.add({
                        summary: 'New User Created Successfully ',
                        severity: 'success',
                        detail: 'User Created....',
                        key: 'success-message',
                        sticky: false
                    });
                    this.router.navigate(['/', 'user-management']);
                }, error => {
                    this.messageService.add({
                        summary: 'Unable to Create New User !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                });
        }
    }

    patchSelectedValue(selectCompany, action: any, event: any) {
        this.selectedBusinessEntityName = selectCompany;
        if (action === 'entityGroup') {
            this.userForm.patchValue({
                businessEntities: null,
                entityName: null,
                businessEntityGroupId: this.selectedBusinessEntityName?.businessEntityGroupId,
            });
        } else if (action === 'multiSelectEntity') {
            this.userForm.patchValue({
                businessEntityGroupId: null,
                groupName: null,
            });
        } else if (action === 'multipleDomain') {
            this.userForm.patchValue({
                domainGroupId: null,
                domainGroupName: null,
            });
        } else if (action === 'domainGroup') {
            this.userForm.patchValue({
                domainGroupId: selectCompany?.domainGroupId,
                domainGroupName: selectCompany?.domainGroupName,
                domains: null,
            });
        }
        if (action === 'entityGroup' && event.value === null) {
            this.userForm.patchValue({
                businessEntityGroupId: null,
            });
        } else if (action === 'domainGroup' && event.value === null) {
            this.userForm.patchValue({
                domainGroupId: null,
                domainGroupName: null,
            });
        }
    }

    onClickCreateBusinessGroup() {
        if (this.businessEntityGroupAction) {
            const businessEntityBody = this.companyGroupListingForm.value;
            this.adminRoute.updateBusinessEntityGroup(businessEntityBody)
                .subscribe((res) => {
                    this.userForm.patchValue({
                        groupName: res.groupName
                    });
                    this.getBusinessEntityGroupList();
                    this.messageService.add({
                        summary: 'Group Updated',
                        severity: 'success',
                        detail: 'Group Updated....',
                        key: 'success-message',
                        sticky: false
                    });
                    this.displayBasic = false;
                }, error => {
                    this.messageService.add({
                        summary: 'Unable to Update Business Group !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                });
        } else {
            const businessEntityBody = this.companyGroupListingForm.value;
            this.adminRoute.createNewBusinessEntityGroup(businessEntityBody)
                .subscribe((res) => {
                    this.displayBasic = false;
                    this.messageService.add({
                        summary: 'Group Created ',
                        severity: 'success',
                        detail: 'Group Created....',
                        key: 'success-message',
                        sticky: false
                    });
                }, error => {
                    this.messageService.add({
                        summary: 'Unable to Create Business Entity Group !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                });
        }
    }

    onClickCreateDomainGroup(action) {
        if (action === 'update') {
            this.adminRoute.updateDomainGroup(this.domainGroupListingForm.value)
                .subscribe((res) => {
                    this.userForm.patchValue({
                        domainGroupName: res.domainGroupName
                    });
                    this.getDomainGroupList();
                    this.displayBasic = false;
                    this.messageService.add({
                        summary: 'Domain Group Created ',
                        severity: 'success',
                        detail: 'Group Created....',
                        key: 'success-message',
                        sticky: false
                    });
                }, (error) => {
                    this.messageService.add({
                        summary: 'Unable to Create Domain Group !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                });
        } else {
            this.adminRoute.createDomainGroup(this.domainGroupListingForm.value)
                .subscribe((res) => {
                    this.displayBasic = false;
                    this.messageService.add({
                        summary: 'Domain Group Created ',
                        severity: 'success',
                        detail: 'Group Created....',
                        key: 'success-message',
                        sticky: false
                    });
                }, (error) => {
                    this.messageService.add({
                        summary: 'Unable to Create Domain Group !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                });
        }
    }

    updatePassword(userRequestBody?: any) {
        userRequestBody = this.userForm.value;
        if (this.userForm?.value.password !== this.userForm?.value.confirmPassword) {
            alert('password Mismatched');
            return;
        }
        this.adminRoute.updateUserPassword(userRequestBody)
            .subscribe((res) => {
                this.messageService.add({
                    summary: 'Password Updated Successfully',
                    severity: 'success',
                    detail: 'Password Updated....',
                    key: 'success-message',
                    sticky: false
                });
                // tslint:disable-next-line:no-shadowed-variable
            }, error => {
                this.messageService.add({
                    summary: 'Unable to Update Password !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    selectedRoles(selection: any, action) {
        console.log(selection, 'selection');
        if (action === 'multipleRoleSelection') {
            this.rolesOfSelectedUser = selection?.value;
        } else {
        }
    }

    onClickCreateNewGroup(action: any) {
        if (action === 'domainGroupList') {
            this.domainGroupForm();
            this.domainGroupAction = false;
            this.toggleGroupForm = false;
        } else {
            this.businessEntityGroupAction = false;
            this.companyGroupForm();
            this.toggleGroupForm = true;
        }
        this.displayBasic = true;
    }

    onClickUpdateBusinessAndDomainGroup(company, action) {
        if (action === 'editBusinessEntityGroup') {
            this.toggleGroupForm = true;
            this.companyGroupForm(company);
            this.businessEntityGroupAction = true;
        } else {
            this.domainGroupAction = true;
            this.toggleGroupForm = false;
            this.domainGroupForm(company);
        }
    }

    createUserForm(userDetailsVo?: any) {
        this.userForm = new FormGroup({
            userId: new FormControl(
                userDetailsVo ? userDetailsVo?.userId : ''
            ),
            firstName: new FormControl(
                userDetailsVo ? userDetailsVo?.firstName : ''
            ),
            lastName: new FormControl(
                userDetailsVo ? userDetailsVo?.lastName : ''
            ),
            phoneNumber: new FormControl(
                userDetailsVo ? userDetailsVo?.phoneNumber : ''
            ),
            emailId: new FormControl(
                userDetailsVo ? userDetailsVo?.emailId : ''
            ),
            whatsAppPhoneNumber: new FormControl(userDetailsVo?.whatsAppPhoneNumber ? userDetailsVo?.whatsAppPhoneNumber : ''),
            whatsAppPhoneStdCode: new FormControl(userDetailsVo?.whatsAppPhoneStdCode ? userDetailsVo?.whatsAppPhoneStdCode : null),
            notificationEmailId: new FormControl(userDetailsVo?.notificationEmailId ? userDetailsVo?.notificationEmailId : ''),
            password: new FormControl(
                userDetailsVo ? userDetailsVo?.password : ''
            ),
            confirmPassword: new FormControl(
                userDetailsVo ? userDetailsVo?.confirmPassword : ''
            ),
            enabled: new FormControl(
                userDetailsVo ? userDetailsVo?.enabled : false
            ),
            businessEntities: new FormControl(
                userDetailsVo ? userDetailsVo?.businessEntities : null
            ),
            businessEntityGroupId: new FormControl(
                userDetailsVo ? userDetailsVo?.businessEntityGroupId : null
            ),
            groupName: new FormControl(
                userDetailsVo ? userDetailsVo?.groupName : null
            ),
            roles: new FormControl(
                userDetailsVo ? userDetailsVo?.roles : null
            ),
            domains: new FormControl(
                userDetailsVo ? userDetailsVo?.domains : null
            ),
            domainGroupName: new FormControl(
                userDetailsVo ? userDetailsVo?.domainGroupName : null
            ),
            domainGroupId: new FormControl(
                userDetailsVo ? userDetailsVo?.domainGroupId : null
            ),
        });
    }

    companyGroupForm(groupListing?: any) {
        this.companyGroupListingForm = new FormGroup({
            businessEntities: new FormControl(
                groupListing ? groupListing?.businessEntities : []
            ),
            groupName: new FormControl(
                groupListing ? groupListing?.groupName : ''
            ),
            businessEntityGroupId: new FormControl(
                groupListing ? groupListing?.businessEntityGroupId : ''
            ),
        });
    }

    domainGroupForm(domainGroupListing?: any) {
        this.domainGroupListingForm = new FormGroup({
            domainGroupId: new FormControl(
                domainGroupListing ? domainGroupListing?.domainGroupId : ''
            ),
            domainGroupName: new FormControl(
                domainGroupListing ? domainGroupListing?.domainGroupName : ''
            ),
            domainVOS: new FormControl(
                domainGroupListing ? domainGroupListing?.domainVOS : []
            ),
        });
    }


    getLoggedInUser(userId) {
        this.imUserService
            .getDetailedLoginUser(userId)
            .subscribe(
                (loggedInUser) => {
                    this.loggedInUser = loggedInUser;
                },
                (error) => {
                    this.messageService.add({
                        summary: 'Logged In User Error!',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: false
                    });
                }
            );
    }

    getStdCodes() {
        this.imUserService.getStdCodes()
            .subscribe((x) => {
                this.stdCodes = x;
            });
    }

    optInForWhatsapp(stdcode: any, phoneNumber: any) {
        const userFormValue = this.userForm.value;
        if (!userFormValue?.whatsAppPhoneNumber && !userFormValue?.whatsAppPhoneStdCode) {
            this.messageService.add({
                summary: 'Whatsapp Error!',
                severity: 'success',
                detail: 'Whatsapp Opt-In - Please Select and Enter the Whatsapp Required Details.',
                key: 'error-message',
                sticky: false
            });
            return;
        }
        this.imUserService.getWhatsappOptIn(stdcode, phoneNumber)
            .subscribe((x) => {
                this.messageService.add({
                    summary: 'Whatsapp !',
                    severity: 'success',
                    detail: 'Whatsapp Opt-In successfully added. Donot forget to save User',
                    key: 'error-message',
                    sticky: false
                });
            }, error => {
                this.messageService.add({
                    summary: 'Whatsapp Opt In Error !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }

    optOutForWhatsapp(stdcode: any, phoneNumber: any) {
        this.imUserService.getWhatsappOptOut(stdcode, phoneNumber.toString())
            .subscribe((x) => {
                this.messageService.add({
                    summary: 'Whatsapp !',
                    severity: 'success',
                    detail: 'Whatsapp Opt-out successfully added. Donot forget to save User',
                    key: 'error-message',
                    sticky: false
                });
                this.userForm.controls?.whatsAppPhoneNumber?.setValue(null);
                this.userForm.controls?.whatsAppPhoneStdCode?.setValue(null);
                this.optAction = 'in';
            }, error => {
                this.messageService.add({
                    summary: 'Whatsapp Opt Out Error !',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'error-message',
                    sticky: false
                });
            });
    }
}
